<template>
    <div :class="className" :style="{ height: eHeight, width: width }" />
  </template>
  <script>
  import * as echarts from "echarts";
  require("echarts/theme/macarons"); // echarts theme
  import resize from "./mixins/resize";
  
  export default {
    mixins: [resize],
    props: {
      className: {
        type: String,
        default: "chart",
      },
      width: {
        type: String,
        default: "100%",
      },
      eHeight: {
        type: String,
        default: "100%",
      },
      autoResize: {
        type: Boolean,
        default: true,
      },
      chartData: {
        type: Object,
        required: false,
      },
    },
    data() {
      return {
        chart: null,
      };
    },
    watch: {
      chartData: {
        deep: true,
        handler(val) {
          this.setOptions(val);
        },
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart();
      });
    },
    beforeDestroy() {
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
    },
    methods: {
      initChart() {
        this.chart = echarts.init(this.$el, "macarons");
        // this.setOptions(this.chartData || {});
      },
      setOptions(data) {
        let _this = this;
        this.chart.setOption({
          tooltip: {
            trigger: "axis",
            backgroundColor:'rgba(255,255,255,1)'
          },
          dataZoom: {
            end: 80,
            type: "inside",
          },
          // legend: {
          //   data: ["新增数", "完成数"],
          //   right: 0,
          //   textStyle: {
          //     color: _this.isbig ? "#AABEFF" : "",
          //   },
          // },
          grid: {
            left: "3%",
            right: "3%",
            bottom: "3%",
            top: "5%",
            containLabel: true,
          },
  
          xAxis: {
            show: true,
            type: "category",
            // boundaryGap: false,
            // axisLabel: {
            //   interval: 0,
            // },
            axisLabel: {
              interval: 0,
              //坐标轴刻度标签的相关设置。
              formatter: function (params) {
                var newParamsName = ""; // 最终拼接成的字符串
                var paramsNameNumber = params.length; // 实际标签的个数
                var provideNumber = 8; // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ""; // 表示每一次截取的字符串
                    var start = p * provideNumber; // 开始截取的位置
                    var end = start + provideNumber; // 结束截取的位置
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr; // 最终拼成的字符串
                  }
                } else {
                  // 将旧标签的值赋给新标签
                  newParamsName = params;
                }
                //将最终的字符串返回
                return newParamsName;
              },
            },
            data: data.xAxisData,
          },
          yAxis: {
            type: "value",
            splitArea: {
              show: false,
            },
            axisLabel: {
              color: _this.isbig ? "#AABEFF" : "#333",
            },
            splitLine: {
              lineStyle: {
                color: _this.isbig ? "#1A48DD" : "#ddd",
              },
            },
          },
          series: [
            {
              name: "具体计划数",
              type: "bar",
              stack: "总量",
              data: data.seriesData,
              barMaxWidth: 20,
              smooth: 0,
            },
            // {
            //   name: "完成数",
            //   type: "line",
            //   stack: "总量",
            //   data: [220, 182, 191, 234, 290, 330, 310],
            //   smooth: 0,
            // },
          ],
        });
      },
    },
  };
  </script>
  